const styles = theme => ({
  titleContainer: {
    marginBottom: [theme.spacing.unit * 2, '!important'],
    position: 'relative'
  },
  titleContainerForSample: {
    marginBottom: [theme.spacing.unit * 3, '!important'],
    position: 'relative'
  },
  title: {
    fontWeight: 'bold !important'
  },
  fieldsMarginBottom: {
    marginBottom: [theme.spacing.unit * 2.5, '!important']
  },
  eProPreview: {
    color: 'rgba(12,31,44,0.38)',
    textAlign: 'center',
    backgroundColor: '#F8FAFC',
    padding: [[theme.spacing.unit * 1.5, 0], '!important'],
    marginTop: [theme.spacing.unit * 3, '!important'],
    marginBottom: [theme.spacing.unit * 3.125, '!important']
  },
  checkboxesContainer: {
    marginTop: 4
  },
  checkboxes: {
    marginRight: theme.spacing.unit * 3,
    '&:last-child': {
      marginRight: 0
    }
  },
  modalFooterForSample: {
    marginTop: theme.spacing.unit * 4
  },
  eProSample: {
    marginBottom: [theme.spacing.unit * 0.5, '!important'],
    '&:last-child': {
      marginBottom: [0, '!important']
    }
  }
});

export default styles;
